import { Member } from "../types/types";
import { fetchAPI } from "../utils";

export const getMember = (memberId: string) =>
  fetchAPI(`/api/v1/members/${memberId}`).get().json<Member>();
